export const FETCH_CATALOGUE_ITEMS_STARTED = "FETCH_CATALOGUE_ITEMS_STARTED";
export const FETCH_CATALOGUE_ITEMS_SUCCEEDED = "FETCH_CATALOGUE_ITEMS_SUCCEEDED";
export const FETCH_CATALOGUE_ITEMS_FAILED = "FETCH_CATALOGUE_ITEMS_FAILED";

export const FETCH_CATALOGUE_CATEGORY_STARTED = "FETCH_CATALOGUE_CATEGORY_STARTED";
export const FETCH_CATALOGUE_CATEGORY_SUCCEEDED = "FETCH_CATALOGUE_CATEGORY_SUCCEEDED";
export const FETCH_CATALOGUE_CATEGORY_FAILED = "FETCH_CATALOGUE_CATEGORY_FAILED";

export const GET_CATALOGUE_STATUS_STARTED = "GET_CATALOGUE_STATUS_STARTED";
export const GET_CATALOGUE_STATUS_SUCCEEDED = "GET_CATALOGUE_STATUS_SUCCEEDED";
export const GET_CATALOGUE_STATUS_FAILED = "GET_CATALOGUE_STATUS_FAILED";

export const FETCH_SALES_DEVICES_STARTED = "FETCH_SALES_DEVICES_STARTED";
export const FETCH_SALES_DEVICES_SUCCEEDED = "FETCH_SALES_DEVICES_SUCCEEDED";
export const FETCH_SALES_DEVICES_FAILED = "FETCH_SALES_DEVICES_FAILED";

export const FETCH_ORDER_HISTORY_STARTED = "FETCH_ORDER_HISTORY_STARTED";
export const FETCH_ORDER_HISTORY_SUCCEEDED = "FETCH_ORDER_HISTORY_SUCCEEDED";
export const FETCH_ORDER_HISTORY_FAILED = "FETCH_ORDER_HISTORY_FAILED";
